import { useCallback, type RefObject } from "react";
import type { IOption } from "../DropdownOption";

type Openable = { close: () => void };

type UseDropdownMenuHandlersParams = {
	ref: RefObject<HTMLDivElement | null>;
	openable: Openable;
	selectedOptions: IOption[];
	onSelect?: (newOption: IOption, options: IOption[]) => void;
	closeOnSelect?: boolean;
};

export function useDropdownMenuHandlers(
	params: UseDropdownMenuHandlersParams,
): { handleSelect: (option: IOption) => void; handleClickOutside: (event: MouseEvent) => void } {
	const { ref, openable, selectedOptions, onSelect, closeOnSelect = true } = params;
	const handleSelect = useCallback(
		(option: IOption) => {
			if (option.notSelectable) return;
			const newOptions = selectedOptions.some((s) => s.id === option.id) ? selectedOptions : [...selectedOptions, option];
			onSelect?.(option, newOptions);
			if (closeOnSelect) {
				openable.close();
			}
		},
		[closeOnSelect, onSelect, openable, selectedOptions],
	);
	const handleClickOutside = useCallback(
		(event: MouseEvent): void => {
			if (ref.current && !ref.current.contains(event.target as Node)) openable.close();
		},
		[openable, ref],
	);
	return { handleSelect, handleClickOutside };
}
